
import { Button, Form, Input, Row, Col } from "antd";
import styled from "styled-components";

export const FormWrapper = styled(Form)`
  padding-top: 10px;
  .ant-form-item {
    margin-bottom: 16px;
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  gap: 8px;

  button {
    min-width: 100px;
  }
`;

export const StyledButton = styled(Button)`
  padding: 20px;
`

export const StyledNumberInput = styled(Input)`
  width: 100%;
  /* Hide number input arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox-specific styling */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const ResponsiveRow = styled(Row)`
  width: 100%;
`;

export const ResponsiveCol = styled(Col)`
  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;
